import { CustomerCrmService } from '@services';
import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-address-form',
  imports: [RmsModule],
  templateUrl: './address-form.component.html',
  styleUrl: './address-form.component.scss'
})
export class AddressFormComponent {
  Address: any = {};
  Contacts:any[]=[];ContactError='';

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef, private crm:CustomerCrmService) {
    this.Address = { ...data };
    if(data.CompanyID)this.crm.getContacts(data.CompanyID).subscribe({next:contacts=>this.Contacts=(contacts||[]).filter((c:any)=>c.IsActive),error:()=>this.ContactError='Contacts could not be loaded. Close and retry.'});
    if (this.Address.IsActive === undefined) this.Address.IsActive = true;
    if (this.Address.IsDefault === undefined) this.Address.IsDefault = false;
  }

  save() {
    this.ref.close({ ...this.Address, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
